import React from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import "../../styles/Stripe.css";
const StripeCheckout = ({ handleSubmit }) => {
  const stripe = useStripe();
  const elements = useElements();
  const Pay = async () => {
    const cardElement = elements.getElement(CardElement);
    const response = await fetch("/stripe/pay", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount: 1000 }),
    });
    const data = await response.json();
    const confirmPayment = await stripe.confirmCardPayment(data.clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });
    const { paymentIntent } = confirmPayment;
    if (paymentIntent.status === "succeeded") {
      //   toast.success("Payment Successful");
      alert("Payment Successful");
      //   setLoading(false);
      // navigate('/success');
    } else {
      //   toast.error("Payment Failed");
      alert("Payment Failed");
      //   setLoading(false);
    }
  };
  return (
    <div className="row justify-content-center align-items-center">
      {" "}
      <CardElement />
      {/* <button onClick={handleSubmit}>Pay</button> */}
      <button onClick={Pay}>Pay</button>
    </div>
  );
};

export default StripeCheckout;
